import {
  SHOW_NOTIFICATION,
  CLEAR_NOTIFICATION
} from './../constants/actionTypes'

const notification = (store = {}, action = {}) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return action.data
    case CLEAR_NOTIFICATION:
      return {}
    default:
      return store
  }
}

export default notification
